import { BookingService } from 'src/app/features/transport-operation/services/booking.service';
import { Injector } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { FileUpload } from 'primeng/fileupload';
import { ViewChild } from '@angular/core';
import { getAllPermission, getDataScopeByPermission } from 'src/app/core/utils/common-functions';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-batch-update-booking',
  templateUrl: './batch-update-booking.component.html',
  styleUrls: ['./batch-update-booking.component.scss']
})
export class BatchUpdateBookingComponent extends SessionBaseComponent implements OnInit {

  readonly preferenceKey: string;
  readonly permissionCodeKey: string;
  isLoading: boolean;
  resultRows: any[] = [];
  columns: any[];
  @ViewChild('fileUpload') fileUpload!: FileUpload;

  constructor(
    injector: Injector,
    private commonDataService: CommonDataService,
    private DOService: DeliveryOrderService,
    private bookingService: BookingService
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.BatchUpdateBooking;
    this.permissionCodeKey = PermissionConstants.BatchUpdatedDeclarationBookingInfo;
    this.isLoading = false;

    this.columns = [
      { field: 'bookingNo', header: 'Booking No.', sort: true },
      { field: 'expressTerm', header: '快遞物流送達條件', sort: true },
      { field: 'hawb', header: 'HAWB', sort: true },
      { field: 'carType', header: '專車類型', sort: true }
    ];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  fileUploader(event: any): void{
    this.isLoading = true;
    this.bookingService.parseBatchUpdateExcel(event.files[0]).subscribe({
      next: result => {
        this.resultRows = result;
      },
      complete: () => {
        this.clearUploadUI();
        this.isLoading = false;
      }
    });
  }

  private clearUploadUI(): void{
    this.fileUpload.clear();
  }

  templateDownloadClickBtn(event: any): void{
    this.commonDataService.getSystemParam('batchUpdatedDeclarationBookingInfo').subscribe({
      next: result => {
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };

        this.DOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = `BatchUpdateBooking.xls`;
          link.click();
        });
      }
    });
  }

  uploadBtnClick(event: any): void{

    var permissions = getAllPermission(this.userProfile);
    console.log(permissions);

    var uploadObj = {
      updatedDatas: this.resultRows,
      userId: this.userProfile.loginAccount,
      userType: this.userProfile.userType,
      dataScopes: getDataScopeByPermission(this.userProfile, this.permissionCodeKey),
      permissions: permissions
    };
    this.loader.show();

    this.bookingService.uploadBatchUpdateExcel(uploadObj).subscribe({
      next: result => {
        this.toastService.success(`總共更新了${result.length}筆資料`);
        this.clearUploadUI();
        this.resultRows = [];
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    })

  }
}
